import type { App } from 'vue'

import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import {
  useBundleStore,
  useCartStore,
  useThemeStore
} from '@/stores'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $bundle: ReturnType<typeof useBundleStore>
    $cart: ReturnType<typeof useCartStore>
    $theme: ReturnType<typeof useThemeStore>
  }
}

export const piniaPlugin = {
  install(app: App) {
    // Setup pinia plugin
    const pinia = createPinia()
    pinia.use(createPersistedState())
    app.use(pinia)

    // Init stores
    const theme = useThemeStore()
    const bundle = useBundleStore()
    const cart = useCartStore()

    app.config.globalProperties.$bundle = bundle
    app.config.globalProperties.$cart = cart
    app.config.globalProperties.$theme = theme

    cart.load()
  }
}

export default piniaPlugin
